import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { forwardRef as v } from "react";
import { c as m } from "./cn-DlLpp5ix.js";
const l = {
  neutral: "var(--text-primary)",
  accent: "var(--accent-default)",
  success: "var(--success)",
  warning: "var(--warning)",
  error: "var(--error)"
}, y = v(function({ value: s, label: c, sublabel: a, icon: n, tone: r = "neutral", align: e = "start", className: i, style: o, ...p }, x) {
  const f = {
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-1)",
    alignItems: e === "center" ? "center" : "flex-start",
    textAlign: e === "center" ? "center" : "left",
    fontFamily: "var(--font-sans)",
    color: "var(--text-primary)",
    ...o
  };
  return /* @__PURE__ */ d(
    "div",
    {
      ref: x,
      "data-ls-component": "stat",
      "data-tone": r,
      "data-align": e,
      className: m(i),
      style: f,
      ...p,
      children: [
        n ? /* @__PURE__ */ t("span", { "aria-hidden": "true", style: { display: "inline-flex", color: l[r] }, children: n }) : null,
        /* @__PURE__ */ t(
          "span",
          {
            style: {
              fontSize: "var(--text-2xl)",
              fontWeight: 800,
              lineHeight: "var(--line-2xl)",
              letterSpacing: "var(--tracking-tight)",
              color: l[r]
            },
            children: s
          }
        ),
        /* @__PURE__ */ t("span", { style: { fontSize: "var(--text-xs)", color: "var(--text-secondary)" }, children: c }),
        a ? /* @__PURE__ */ t("span", { style: { fontSize: "var(--text-2xs)", color: "var(--text-tertiary)" }, children: a }) : null
      ]
    }
  );
});
y.displayName = "Stat";
export {
  y as S
};
//# sourceMappingURL=Stat-DaYLkgFc.js.map
